export const PAGE_NAME = {
    SUMMARY: "Summary",
    SUMMARY_FOR_CITY: "SummaryForCity",
    SOIL_RAIN: "SoilRain",
    AREA_RISK: "AreaRisk",
    RIVER: "River",
    SENIOR_RISK: "SeniorRisk",
    ROAD_RISK: "RoadRisk",
    RAILWAY_RISK: "RailwayRisk",
    CHRONOLOGY: "Chronology",
    COMPATIBILITY: "Compatibility",
    USER_REGISTER_FORM: "UserRegisterForm",
    RISK_ANALYSIS: "RiskAnalysis",
    TYPHOON: "Typhoon",
    RISK : "Risk",
    SHELTER_ANALYSIS: "ShelterAnalysis"
}

export const DATA_TYPE = {
    RSK: 0,
    SR: 1,
    RAIN: 2,
    BSN: 3,
    TEL: 4,
    LANDSLIDE_IMPACT: 5,
    FLOOD_IMPACT: 6,
}
